import {
	comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
	var obj = {
		headData: [{
				title: "行次",
				prop: "hc",
				width: 30,
				custom: true
			},
			{
				title: "项目",
				width: "200px",
				prop: "tes1",
				align: "left",
			},
			{
				title: "金额(数量)",
				width: "80",
				AmountFormat: true,
				align: "right",
				prop: "xmwd",
				custom: true
			},

		],
		tableData: [{
				tes1: '本年可享受研发费用加计扣除项目数量',
				xmwd: {
					cellCode: 'xmwd_0_1_1',
					cellVal: 0,
				},
			},
			{
				tes1: '一、自主研发、合作研发、集中研发（3+7+16+19+23+34）',
				xmwd: {
					cellCode: 'xmwd_0_1_2',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '（一）人员人工费用（4+5+6）',
				xmwd: {
					cellCode: 'xmwd_0_1_3',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '1.直接从事研发活动人员工资薪金',
				xmwd: {
					cellCode: 'xmwd_0_1_4',
					cellVal: 0,
				},
			},
			{
				tes1: '2.直接从事研发活动人员五险一金',
				xmwd: {
					cellCode: 'xmwd_0_1_5',
					cellVal: 0,
				},
			},
			{
				tes1: '3.外聘研发人员的劳务费用',
				xmwd: {
					cellCode: 'xmwd_0_1_6',
					cellVal: 0,
				},
			},
			{
				tes1: '（二）直接投入费用（8+9+10+11+12+13+14+15）',
				xmwd: {
					cellCode: 'xmwd_0_1_7',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '1.研发活动直接消耗材料费用',
				xmwd: {
					cellCode: 'xmwd_0_1_8',
					cellVal: 0,
				},
			},
			{
				tes1: '2.研发活动直接消耗燃料费用',
				xmwd: {
					cellCode: 'xmwd_0_1_9',
					cellVal: 0,
				},
			},
			{
				tes1: '3.研发活动直接消耗动力费用',
				xmwd: {
					cellCode: 'xmwd_0_1_10',
					cellVal: 0,
				},
			},
			{
				tes1: '4.用于中间试验和产品试制的模具、工艺装备开发及制造费',
				xmwd: {
					cellCode: 'xmwd_0_1_11',
					cellVal: 0,
				},
			},
			{
				tes1: '5.用于不构成固定资产的样品、样机及一般测试手段购置费',
				xmwd: {
					cellCode: 'xmwd_0_1_12',
					cellVal: 0,
				},
			},
			{
				tes1: '6.用于试制产品的检验费',
				xmwd: {
					cellCode: 'xmwd_0_1_13',
					cellVal: 0,
				},
			},
			{
				tes1: '7.用于研发活动的仪器、设备的运行维护、调整、检验、维修等费用',
				xmwd: {
					cellCode: 'xmwd_0_1_14',
					cellVal: 0,
				},
			},
			{
				tes1: '8.通过经营租赁方式租入的用于研发活动的仪器、设备租赁费',
				xmwd: {
					cellCode: 'xmwd_0_1_15',
					cellVal: 0,
				},
			},
			{
				tes1: '（三）折旧费用（17+18）',
				xmwd: {
					cellCode: 'xmwd_0_1_16',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '1.用于研发活动的仪器的折旧费',
				xmwd: {
					cellCode: 'xmwd_0_1_17',
					cellVal: 0,
				},
			},
			{
				tes1: '2.用于研发活动的设备的折旧费',
				xmwd: {
					cellCode: 'xmwd_0_1_18',
					cellVal: 0,
				},
			},
			{
				tes1: '（四）无形资产摊销（20+21+22）',
				xmwd: {
					cellCode: 'xmwd_0_1_19',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '1.用于研发活动的软件的摊销费用',
				xmwd: {
					cellCode: 'xmwd_0_1_20',
					cellVal: 0,
				},
			},
			{
				tes1: '2.用于研发活动的专利权的摊销费用',
				xmwd: {
					cellCode: 'xmwd_0_1_21',
					cellVal: 0,
				},
			},
			{
				tes1: '3.用于研发活动的非专利技术（包括许可证、专有技术、设计和计算方法等）的摊销费用',
				xmwd: {
					cellCode: 'xmwd_0_1_22',
					cellVal: 0,
				},
			},
			{
				tes1: '（五）新产品设计费等（24+25+26+27）',
				xmwd: {
					cellCode: 'xmwd_0_1_23',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '1.新产品设计费',
				xmwd: {
					cellCode: 'xmwd_0_1_24',
					cellVal: 0,
				},
			},
			{
				tes1: '2.新工艺规程制定费',
				xmwd: {
					cellCode: 'xmwd_0_1_25',
					cellVal: 0,
				},
			},
			{
				tes1: '3.新药研制的临床试验费',
				xmwd: {
					cellCode: 'xmwd_0_1_26',
					cellVal: 0,
				},
			},
			{
				tes1: '4.勘探开发技术的现场试验',
				xmwd: {
					cellCode: 'xmwd_0_1_27',
					cellVal: 0,
				},
			},
			{
				tes1: '（六）其他相关费用(29+30+31+32+33)',
				xmwd: {
					cellCode: 'xmwd_0_1_28',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '1.技术图书资料费、资料翻译费、专家咨询费、高新科技研发保险费',
				xmwd: {
					cellCode: 'xmwd_0_1_29',
					cellVal: 0,
				},
			},
			{
				tes1: '2.研发成果的检索、分析、评议、论证、鉴定、评审、评估、验收费用',
				xmwd: {
					cellCode: 'xmwd_0_1_30',
					cellVal: 0,
				},
			},
			{
				tes1: '3.知识产权的申请费、注册费、代理费',
				xmwd: {
					cellCode: 'xmwd_0_1_31',
					cellVal: 0,
				},
			},
			{
				tes1: '4.职工福利费、补充养老保险费、补充医疗保险费',
				xmwd: {
					cellCode: 'xmwd_0_1_32',
					cellVal: 0,
				},
			},
			{
				tes1: '5.差旅费、会议费',
				xmwd: {
					cellCode: 'xmwd_0_1_33',
					cellVal: 0,
				},
			},
			{
				tes1: '（七）经限额调整后的其他相关费用',
				xmwd: {
					cellCode: 'xmwd_0_1_34',
					cellVal: 0,
				},
			},
			{
				tes1: '二、委托研发 (36+37+39)',
				xmwd: {
					cellCode: 'xmwd_0_1_35',
					cellVal: 0,
				},
			},
			{
				tes1: '（一）委托境内机构或个人进行研发活动所发生的费用',
				xmwd: {
					cellCode: 'xmwd_0_1_36',
					cellVal: 0,
				},
			},
			{
				tes1: '（二）委托境外机构进行研发活动发生的费用',
				xmwd: {
					cellCode: 'xmwd_0_1_37',
					cellVal: 0,
				},
			},
			{
				tes1: '其中：允许加计扣除的委托境外机构进行研发活动发生的费用',
				xmwd: {
					cellCode: 'xmwd_0_1_38',
					cellVal: 0,
				},
			},
			{
				tes1: '（三）委托境外个人进行研发活动发生的费用',
				xmwd: {
					cellCode: 'xmwd_0_1_39',
					cellVal: 0,
				},
			},
			{
				tes1: '三、年度研发费用小计(2+36×80%+38)',
				xmwd: {
					cellCode: 'xmwd_0_1_40',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '（一）本年费用化金额',
				xmwd: {
					cellCode: 'xmwd_0_1_41',
					cellVal: 0,
				},
			},
			{
				tes1: '（二）本年资本化金额',
				xmwd: {
					cellCode: 'xmwd_0_1_42',
					cellVal: 0,
				},
			},
			{
				tes1: '四、本年形成无形资产摊销额',
				xmwd: {
					cellCode: 'xmwd_0_1_43',
					cellVal: 0,
				},
			},
			{
				tes1: '五、以前年度形成无形资产本年摊销额',
				xmwd: {
					cellCode: 'xmwd_0_1_44',
					cellVal: 0,
				},
			},
			{
				tes1: '六、允许扣除的研发费用合计（41+43+44）',
				xmwd: {
					cellCode: 'xmwd_0_1_45',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '减：特殊收入部分',
				xmwd: {
					cellCode: 'xmwd_0_1_46',
					cellVal: 0,
				},
			},
			{
				tes1: '七、允许扣除的研发费用抵减特殊收入后的金额(45-46)',
				xmwd: {
					cellCode: 'xmwd_0_1_47',
					cellVal: 0,
					disabled:true,
				},
			},
			{
				tes1: '减：当年销售研发活动直接形成产品（包括组成部分）对应的材料部分',
				xmwd: {
					cellCode: 'xmwd_0_1_48',
					cellVal: 0,
				},
			},
			{
				tes1: '减：以前年度销售研发活动直接形成产品（包括组成部分）对应材料部分结转金额',
				xmwd: {
					cellCode: 'xmwd_0_1_49',
					cellVal: 0,
				},
			},
			{
				tes1: '八、加计扣除比例（%）',
				xmwd: {
					cellCode: 'xmwd_0_1_50',
					cellVal: 0,
				},
			},
			{
				tes1: '九、本年研发费用加计扣除总额（47-48-49）×50',
				xmwd: {
					cellCode: 'xmwd_0_1_51',
					disabled:true,
					cellVal: 0,
				},
			},
			{
				tes1: '十、销售研发活动直接形成产品（包括组成部分）对应材料部分结转以后年度扣减金额（当47-48-49≥0，本行＝0；当47-48-49＜0，本行＝47-48-49的绝对值)',
				xmwd: {
					cellCode: 'xmwd_0_1_52',
					cellVal: 0,
					disabled:true,
				},
			}
		],
	}
	return obj
}
